// import React from 'react';

// function TestimonialCard({ name, role, description, image, rating }) {
//     return (
//         <div className="shadow-lg rounded-lg p-6 bg-white">
//             <img src={image} alt={name} className="w-20 h-20 rounded-full mx-auto mb-4" />
//             <p className="text-lg font-bold text-center">{name}</p>
//             <p className="text-sm text-gray-500 text-center">{role}</p>
//             <p className="text-sm text-gray-700 text-center mt-4">{description}</p>
//             <div className="text-center mt-4">
//                 {'★'.repeat(rating)}{'☆'.repeat(5 - rating)}
//             </div>
//         </div>
//     );
// }

// export default TestimonialCard;

// TestimonialCard.jsx
import React from 'react';

function TestimonialCard({ name, role, description, image, rating }) {
    return (
        <div className=" border border-[#5ecaf4] rounded-xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 h-full">
            {/* Rating Stars */}
            <div className="flex justify-center mb-4">
                <div className="flex text-yellow-400 text-lg">
                    {'★'.repeat(rating)}{'☆'.repeat(5 - rating)}
                </div>
            </div>
            
            {/* Testimonial Text */}
            <div className="flex-grow">
                <p className="text-gray-200 text-center italic text-sm leading-relaxed">
                    "{description}"
                </p>
            </div>

            {/* Client Info with Image */}
            <div className="flex items-center justify-center mt-6 space-x-4">
                <div className="flex-shrink-0">
                    <img 
                        src={image} 
                        alt={`${name} - ${role}`} 
                        className="w-16 h-16 rounded-full border-2 border-[#5ecaf4] object-cover"
                        loading="lazy"
                    />
                </div>
                <div className="text-center">
                    <p className="text-white font-semibold text-lg">{name}</p>
                    <p className="text-[#5ecaf4] text-sm">{role}</p>
                </div>
            </div>
        </div>
    );
}

export default TestimonialCard;